export enum HardwareVersions {
  MODULO5 = 'MODULO5',
  SPOM4 = 'SPOM4',
  OLDER = 'OLDER',
}
